export default (state = {}, action) => {
  switch( action.type ) {
    case 'MEDIUMS_LOADED':
      return {
        ...state,
        mediums: action.mediums
      };
    case 'MEDIUM_CLICK':
      return {
        ...state,
        medium: action.payload
      }
    default:
      return state;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/mediums.js